import { render, staticRenderFns } from "./BusList.vue?vue&type=template&id=68931ae8&scoped=true&"
import script from "./BusList.vue?vue&type=script&lang=js&"
export * from "./BusList.vue?vue&type=script&lang=js&"
import style0 from "./BusList.vue?vue&type=style&index=0&id=68931ae8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68931ae8",
  null
  
)

export default component.exports